module.exports = __webpack_public_path__ + "img/icon3.8493fe4c.png";